import * as ActionTypes from '../constants/actionTypes'
import api from '../utils/api'
import getFieldFromItem from '../utils/getFieldFromItem'

export const keys = []

export const editForm = formFieldsChange => ({
  type: ActionTypes.ADMINISTRATORFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.ADMINISTRATORFORM_ENTER_RESET,
})

export const fetchItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.ADMINISTRATORFORM_FETCHITEM_LOAD })
  try {
    let item = await api.get(`administrators/${params.id}`)
    dispatch({
      type: ActionTypes.ADMINISTRATORFORM_FETCHITEM_SUCCEED,
      item,
    })
    const field = getFieldFromItem(
      item,
      //keys,
    )
    dispatch({
      type: ActionTypes.ADMINISTRATORFORM_EDITFORM_CHANGE,
      field,
    })
  } catch (error) {
    dispatch({
      type: ActionTypes.ADMINISTRATORFORM_FETCHITEM_FAIL,
      fetchItemError: error.message,
    })
  }
}

export const createItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.ADMINISTRATORFORM_CREATEITEM_LOAD })
  try {
    await api.create(`administrators`, params)
    dispatch({ type: ActionTypes.ADMINISTRATORLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.ADMINISTRATORFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.ADMINISTRATORFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.ADMINISTRATORFORM_CREATEITEM_FAIL,
      createItemError: error.message,
    })
  }
}

export const editItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.ADMINISTRATORFORM_EDITITEM_LOAD })
  let lParams = params
  if (lParams.password === '') {
    delete lParams.password
  }
  try {
    await api.patch(`administrators/${params.id}`, lParams)
    dispatch({ type: ActionTypes.ADMINISTRATORFORM_EDITITEM_SUCCEED })
  } catch (error) {
    dispatch({
      type: ActionTypes.ADMINISTRATORFORM_EDITITEM_FAIL,
      editItemError: error.message,
    })
  }
}

export const deleteItem = params => async (dispatch) => {
  dispatch({ type: ActionTypes.ADMINISTRATORFORM_DELETEITEM_LOAD })
  try {
    await api.delete(`administrators/${params.id}`)
    dispatch({ type: ActionTypes.ADMINISTRATORFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.ADMINISTRATORFORM_ENTER_RESET })
  } catch (error) {
    dispatch({
      type: ActionTypes.ADMINISTRATORFORM_DELETEITEM_FAIL,
      deleteItemError: error.message,
    })
  }
}
